module.exports = __webpack_public_path__ + "static/media/step2.25ef93b9.svg";